var React = require('react');

function FacebookIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.6752 0H1.3248C0.59328 0 0 0.576189 0 1.28663V22.022C0 22.7324 0.59328 23.3086 1.3248 23.3086H12.8189V14.2826H9.6912V10.7648H12.8189V8.17013C12.8189 5.15959 14.712 3.52053 17.4778 3.52053C18.8026 3.52053 19.9411 3.61656 20.2723 3.65945V6.80611L18.3542 6.80704C16.8499 6.80704 16.559 7.50071 16.559 8.51976V10.7658H20.1456L19.6781 14.2835H16.5581V23.3086H22.6752C23.4067 23.3086 24 22.7324 24 22.022V1.28663C24 0.576189 23.4067 0 22.6752 0Z","fill":"#BA5C24"}));
}

FacebookIconInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","className":"svg"};

module.exports = FacebookIconInline;

FacebookIconInline.default = FacebookIconInline;
